import React from 'react'
import { Helmet } from 'react-helmet';
import AssignmentMark from '../components/assignmentMark/assignmentMark';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar';
import { useGetAssignmentMarksQuery } from '../features/assignmentMarks/assignmentMarksApi';

function AssignmentMarks() {

	//Variabes
	const { data: marks, isLoading, isError } = useGetAssignmentMarksQuery() || {};
	const publishedCount = marks?.filter(mark => mark.status === "published").length;
	const pendingCount = marks?.filter(mark => mark.status === "pending").length;

	//Decide what to render
	let content = null;

	if (isLoading) {
		content = <Loader />
	}
	if (!isLoading && isError) {
		content = <Error message="There was an error occured!" />
	}
	if (!isLoading && !isError && marks.length === 0) {
		content = <div className='text-center'>No Assignment Mark Found</div>
	}
	if (!isLoading && !isError && marks.length > 0) {
		content = (
			<div className="overflow-x-auto mt-4">
				<table className="divide-y-1 text-base divide-gray-600 w-full">
					<thead>
						<tr>
							<th className="table-th">Assignment</th>
							<th className="table-th">Date</th>
							<th className="table-th">Student Name</th>
							<th className="table-th">Repo Link</th>
							<th className="table-th">Mark</th>
						</tr>
					</thead>
					<tbody className="divide-y divide-slate-600/50">
						{marks.map((mark) => (<AssignmentMark key={mark.id} mark={mark} />))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<Helmet>
				<title>Assignment Marks</title>
			</Helmet>
			<Navbar />
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-full px-5 lg:px-20">
					<div className="px-3 py-20 bg-opacity-10">
						<ul className="assignment-status">
							<li>Total <span>{marks?.length}</span></li>
							<li>Pending <span>{pendingCount}</span></li>
							<li>Mark Sent <span>{publishedCount}</span></li>
						</ul>
						{content}
					</div>
				</div>
			</section>
		</>
	)
}

export default AssignmentMarks